import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';
import { CommonService } from '../../common.service';
declare var $: any;
@Component({
  selector: 'app-editfarmsmanagement',
  templateUrl: './editfarmsmanagement.component.html',
  styleUrls: ['./editfarmsmanagement.component.css']
})
export class EditfarmsmanagementComponent implements OnInit {
  returnUrl= "/dashboard/farmsmanagement";
  getfarmseditApi: string;
  putfarmseditApi:any;
  editfarmsFormValue:any;
  addUrl:any;
  loginresponse:any;
  cby_mby:any;
  constructor(private router: Router,private commonService: CommonService) { }

  async ngOnInit() {
    this.loginresponse=JSON.parse(sessionStorage.getItem('userrole'));
    this.cby_mby=this.loginresponse.user_id;
    $('.selectpicker').selectpicker('refresh');
    let farmsId = sessionStorage.getItem('farmsId');
    console.log(farmsId);
    this.getfarmseditApi= "/farms/"+ farmsId;
    this.putfarmseditApi= "/farms/"+ farmsId;
    (await this.commonService.getApi(this.getfarmseditApi)).subscribe(
      res => {
        console.log(res.data);
       $("#farmname").val(res.data.tnfr_name),
        $("#farmid").val(res.data.tnfr_code),
        $("#farmcontactname").val(res.data.tnfr_farm_contact_name),
        $("#farmcontactemail").val(res.data.tnfr_farm_contact_email),
        $("#ContactNumber").val(res.data.tnfr_farm_contact_number),
        $("#Address").val(res.data.tnfr_farm_address)
      
      })
  }
  async farmsmanagement(){
    this.editfarmsFormValue = {
      "farm_name": $("#farmname").val(),
      "code":$("#farmid").val(),
      "farm_contact_name":$("#farmcontactname").val(),
      "farm_contact_email":$("#farmcontactemail").val(),
      "farm_contact_number":$("#ContactNumber").val(),
      "farm_address":$("#Address").val(),
      "status" : 1,
      "cby": this.cby_mby,
      "mby": this.cby_mby
  };
 
    (await this.commonService.putApi(this.putfarmseditApi,this.editfarmsFormValue)).subscribe(
      data => {
          alert("Data edited Successfully");
          setTimeout(
            () : void => {
    
              this.router.navigate([this.returnUrl]);
    
            },
            500
          );
      },
      err => {
        Swal.fire("Duplicate values",'Farm Id already Exist');
      });
     
  }
  backnavigate(){
    this.router.navigate([this.returnUrl]);
  }
}
